import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { login as authLogin } from '../../services/authService'
import { Eye, EyeOff, ArrowRight, Building2, ArrowLeft } from 'lucide-react'
import './styles.scss'

export default function Login() {
  const { login } = useAuth()
  const navigate = useNavigate()

  const [form, setForm] = useState({ email: '', password: '' })
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      const data = await authLogin(form.email, form.password)

      if (data.success) {
        login(data.token, data.user)
        navigate('/dashboard')
      } else {
        setError(data.message || 'Invalid email or password.')
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      {/* Left: Branding Panel */}
      <div className="auth-brand">
        <Link to="/" className="back-home-link">
          <ArrowLeft size={16} /> Home
        </Link>
        <div className="auth-brand__content">
          <Link to="/" className="auth-brand__logo" style={{ textDecoration: 'none' }}>
            <img src="/campusready_logo.svg" alt="CampusReady" />
            <span>CampusReady<span className="ai">.ai</span></span>
          </Link>
          <h1>Simplify International Admissions</h1>
          <p>AI-powered document review, real-time updates, and clear next steps — all in one place.</p>

          <div className="auth-brand__features">
            {/*
            <div className="feature-pill">
              <Building2 size={16} />
              <span>Trusted by 50+ universities</span>
            </div>
            <div className="feature-pill">
              <ArrowRight size={16} />
              <span>10,000+ students processed</span>
            </div>
            */}
          </div>
        </div>

        {/* Decorative dots */}
        <div className="auth-brand__dots" />
      </div>

      {/* Right: Login Form */}
      <div className="auth-form-panel">
        <div className="auth-form-container">
          <div className="auth-form-header">
            <h2>Welcome back</h2>
            <p>Sign in to your account to continue</p>
          </div>

          {error && (
            <div className="auth-error">
              <span>{error}</span>
            </div>
          )}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@university.edu"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-wrap">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  className="eye-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              <div style={{ marginTop: '8px', textAlign: 'right' }}>
                <Link to="/forgot-password" className="forgot-link">Forgot password?</Link>
              </div>
            </div>

            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? (
                <span className="spinner" />
              ) : (
                <>Sign In <ArrowRight size={16} /></>
              )}
            </button>
          </form>

          <p className="auth-footer-text">
            Don't have an account? <Link to="/register">Create one</Link>
          </p>
        </div>
      </div>
    </div>
  )
}
